<h3 class="month-heading" *ngIf="heading">{{ heading }}</h3>

<div class="month" [ngClass]="density">
  <div class="weekday" *ngFor="let weekday of weekdays">{{ density === 'mini' ? weekday.charAt(0) : weekday }}</div>

  <div class="day" *ngFor="let day of days; trackBy: trackDay" [class.outside]="!inMonth(day)"
    [class.today]="day === today" [class.selectable]="selectable || density === 'mini'"
    [class.has-items]="density === 'mini' && inMonth(day) && dayItems(day).length > 0"
    (click)="onDayClick($event, day)">
    <span class="day-number">{{ dayNumber(day) }}</span>

    <!-- Jahr: nur farbige Punkte je Eintrag (Details per Klick in der Woche) -->
    <span class="dots" *ngIf="density === 'mini' && inMonth(day)">
      <span class="dot" *ngFor="let item of dayItems(day) | slice:0:maxPerDay; trackBy: trackItem" [ngClass]="item.kind"
        [style.--item-color]="item.color" cdkOverlayOrigin #dotOrigin="cdkOverlayOrigin"
        (mouseenter)="hoverKey = day + '|' + item.key" (mouseleave)="hoverKey = null">
        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="dotOrigin"
          [cdkConnectedOverlayOpen]="hoverKey === day + '|' + item.key" [cdkConnectedOverlayPositions]="tooltipPositions"
          [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12">
          <ng-container *ngTemplateOutlet="tooltipTpl; context: { $implicit: item }"></ng-container>
        </ng-template>
      </span>
    </span>

    <ng-container *ngIf="density !== 'mini'">
      <button type="button" class="entry" *ngFor="let item of dayItems(day) | slice:0:maxPerDay; trackBy: trackItem"
        [ngClass]="item.kind" [class.locked]="!item.editable && item.kind === 'assignment'"
        [style.--item-color]="item.color" [attr.aria-label]="item.label + ': ' + item.title"
        cdkOverlayOrigin #entryOrigin="cdkOverlayOrigin"
        (mouseenter)="hoverKey = day + '|' + item.key" (mouseleave)="hoverKey = null"
        (click)="hoverKey = null; itemClick.emit(item)">
        <mat-icon *ngIf="item.kind === 'outlook'">event_note</mat-icon>
        <mat-icon *ngIf="item.kind === 'absence'">beach_access</mat-icon>
        <span class="time" *ngIf="timePrefix(item, day)">{{ timePrefix(item, day) }}</span>
        <span class="title">{{ item.title }}</span>

        <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="entryOrigin"
          [cdkConnectedOverlayOpen]="hoverKey === day + '|' + item.key" [cdkConnectedOverlayPositions]="tooltipPositions"
          [cdkConnectedOverlayPush]="true" [cdkConnectedOverlayViewportMargin]="12">
          <ng-container *ngTemplateOutlet="tooltipTpl; context: { $implicit: item }"></ng-container>
        </ng-template>
      </button>

      <button type="button" class="more" *ngIf="dayItems(day).length > maxPerDay" (click)="dayOpen.emit(day)">
        + {{ dayItems(day).length - maxPerDay }} weitere
      </button>
    </ng-container>
  </div>
</div>

<!-- Gemeinsamer Termin-Tooltip (wie in der Teamplanung) -->
<ng-template #tooltipTpl let-item>
  <app-resource-assignment-tooltip [category]="tooltip(item).category" [title]="item.title"
    [startDate]="item.startDate" [endDate]="item.endDate" [startTime]="item.startTime" [endTime]="item.endTime"
    [allDay]="tooltip(item).allDay" [utilizationPercent]="tooltip(item).utilizationPercent"
    [location]="item.location || null" [footerText]="tooltip(item).footerText" [footerIcon]="tooltip(item).footerIcon">
  </app-resource-assignment-tooltip>
</ng-template>
